// extracted by mini-css-extract-plugin
export var button = "_o5-2";
export var card = "_o5-0";
export var closeButtonContainer = "_o5-3";
export var iconContainer = "_o5-1";